export const LOGO_URL= "https://img.freepik.com/free-vector/food-delivery-illustration-with-bike-man-courier_1308-51210.jpg?size=626&ext=jpg";

export const RESIMG_URL="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";

export const CART_IMG='https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/2xempty_cart_yfxml0';